import axios from 'axios';
import { KpiDefinition } from '../interfaces/athlete';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SETTING_NAME = 'padeltech_performance_kpis';

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    };
};

/**
 * Get all KPI definitions from settings
 */
export function getKpiDefinitions() {
    const endpointUrl = `${API_BASE_URL}/wp-json/padeltech/ws/v1/settings/${SETTING_NAME}`;
    return axios.get(endpointUrl, { headers: getHeaders() });
}

/**
 * Save all KPI definitions to settings
 */
export function saveKpiDefinitions(kpiDefinitions: KpiDefinition[]) {
    // Clean up: remove local ID and audit fields before saving
    const cleanedKpis = kpiDefinitions.map(({ id, created_by, created_at, changed_by, changed_at, ...kpi }) => kpi);

    const endpointUrl = `${API_BASE_URL}/wp-json/padeltech/ws/v1/settings`;
    return axios.post(endpointUrl, {
        setting_name: SETTING_NAME,
        setting_value: cleanedKpis
    }, { headers: getHeaders() });
}
